module.exports = __webpack_public_path__ + "img/button-text-ganga7.2244910e.png";